export const ArcadeIcon = () => {
  return <img className='w-full h-[24px]' src='/images/retro/arcade.png' />
}
